export enum LoaderType {
  Animations = 'animations_loader',
  Audio = 'audio_loader',
  EnvMap = 'env_map_loader',
  Material = 'material_loader',
  Model3d = 'model3d_loader',
  Texture = 'texture_loader'
}
